import React, {FC} from "react";
import {cva, cx} from "@panda/css";

import {navigationHeight} from "@pg-rp/navigation";

import {isBrowser} from "../app/read_rp_environment_variables";
import {useHeightObserver} from "../hooks/use_height_observer";

interface IDesktopBlend {
    children?: React.ReactNode;
    pageHeight?: string;
    isActive: boolean;
    top?: string;
    heightDecrease?: string;
    isFullScreen?: boolean;
    isViewportWidth?: boolean;
    className?: string;
}

export const DesktopBlend: FC<IDesktopBlend> = (props) => {
    const {pageHeight, top, heightDecrease, isActive, isFullScreen, isViewportWidth, className, children} = props;
    const {height: pageHeightLocalState, ref} = useHeightObserver({
        isActive: !isFullScreen && isActive,
        initialHeight: 0
    });

    if (isBrowser && !ref.current) {
        ref.current = document.body;
    }

    const blendHeight = pageHeightLocalState ? `${pageHeightLocalState}px` : (pageHeight ?? "100vh");
    const blendStyle: React.CSSProperties & Record<"--desktop-blend-top" | "--desktop-blend-height", string> = {
        "--desktop-blend-top": `calc(${top || "0"} + ${navigationHeight}px)`, // offset for navigation height
        "--desktop-blend-height": `calc(${blendHeight} - ${heightDecrease || `${navigationHeight}px`})`
    };

    return (
        <div className={cx(desktopBlend({isActive, isViewportWidth, isFullScreen}), className)} style={blendStyle}>
            {children}
        </div>
    );
};

const desktopBlend = cva({
    base: {
        display: "none",
        md: {
            position: "absolute",
            zIndex: 1000,
            left: 0,
            width: "100%",
            transform: "none",
            top: "var(--desktop-blend-top)",
            height: "var(--desktop-blend-height)",
            backgroundColor: "secondary/75",
            animationStyle: "fade-in"
        }
    },
    variants: {
        isActive: {
            true: {
                md: {
                    display: "block"
                }
            }
        },
        isViewportWidth: {
            true: {
                md: {
                    left: "50%",
                    width: "100vw",
                    transform: "translateX(-50%)"
                }
            }
        },
        isFullScreen: {
            true: {
                md: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    transform: "none"
                }
            }
        }
    }
});
import React, {FC} from "react";
import {cva, cx} from "@panda/css";

import {navigationHeight} from "@pg-rp/navigation";

import {isBrowser} from "../app/read_rp_environment_variables";
import {useHeightObserver} from "../hooks/use_height_observer";

interface IDesktopBlend {
    children?: React.ReactNode;
    pageHeight?: string;
    isActive: boolean;
    top?: string;
    heightDecrease?: string;
    isFullScreen?: boolean;
    isViewportWidth?: boolean;
    className?: string;
}

export const DesktopBlend: FC<IDesktopBlend> = (props) => {
    const {pageHeight, top, heightDecrease, isActive, isFullScreen, isViewportWidth, className, children} = props;
    const {height: pageHeightLocalState, ref} = useHeightObserver({
        isActive: !isFullScreen && isActive,
        initialHeight: 0
    });

    if (isBrowser && !ref.current) {
        ref.current = document.body;
    }

    const blendHeight = pageHeightLocalState ? `${pageHeightLocalState}px` : (pageHeight ?? "100vh");
    const blendStyle: React.CSSProperties & Record<"--desktop-blend-top" | "--desktop-blend-height", string> = {
        "--desktop-blend-top": `calc(${top || "0"} + ${navigationHeight}px)`, // offset for navigation height
        "--desktop-blend-height": `calc(${blendHeight} - ${heightDecrease || `${navigationHeight}px`})`
    };

    return (
        <div className={cx(desktopBlend({isActive, isViewportWidth, isFullScreen}), className)} style={blendStyle}>
            {children}
        </div>
    );
};

const desktopBlend = cva({
    base: {
        display: "none",
        md: {
            position: "absolute",
            zIndex: 1000,
            left: 0,
            width: "100%",
            transform: "none",
            top: "var(--desktop-blend-top)",
            height: "var(--desktop-blend-height)",
            backgroundColor: "secondary/75",
            animationStyle: "fade-in"
        }
    },
    variants: {
        isActive: {
            true: {
                md: {
                    display: "block"
                }
            }
        },
        isViewportWidth: {
            true: {
                md: {
                    left: "50%",
                    width: "100vw",
                    transform: "translateX(-50%)"
                }
            }
        },
        isFullScreen: {
            true: {
                md: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    transform: "none"
                }
            }
        }
    }
});
